<template>
    <div class="flex pt-2 justify-between items-start">
        <SearchInput v-model="search" class="w-[405px]" @input="onSearch" @clear="onClear" />
        <div class="flex items-center"> 
            <btn class="mr-9" v-if="!archive" @click="onCreate">+ Создать</btn>
            <icon class="cursor-pointer"><IconDocExport /></icon>
        </div>
    </div>
</template>

<script setup lang="ts">
import SearchInput from './SearchInput.vue'
import IconDocExport from '@/ui/icons/IconDocExport.vue'
import { ref } from 'vue'

defineProps({
    archive: Boolean
})

const search = ref('')
const emit = defineEmits(['search-input', 'create'])

const onSearch = () => {
    emit('search-input', search.value)
}

const onClear = () => {
    search.value = ''
    onSearch()
}

const onCreate = () => {
    emit('create')
}
</script>
